import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Link, Redirect } from 'react-router-dom';

import Img from '../../components/Img';
import ClubSelectForm from '../../components/ClubSelectForm';
import EventTemplateCard from '../../components/cards/EventTemplateCard';
import { isActive as isClubActive, canRunEvents as clubCanRunEvents, getNewClubPath } from '../../utils/clubs';
import { getClubListForCreateEvent } from '../../utils/events';
import * as eventTemplateActions from '../../actions/event-template-actions';
import * as splashActions from '../../actions/splash-actions';
import { sportTypeIds } from '../../utils/eventConstants';
import config from '../../../config';
import { useStatsig } from '../../components/hooks/useStatsig';

import styles from './eventCreate.scss';

const EventCreateTemplates = (props) => {
    const {
        club,
        clubIdInUrl,
        handleToCreateForm,
        eventTemplates,
        showSplash,
        hideSplash,
        getClubEventTemplates,
        sportTypeId,
    } = props;

    const { checkGate, featureGates } = useStatsig();
    const isClubRedirectEnabled = checkGate(featureGates.CLUB_LINKS_REDIRECT);

    const getTemplates = async () => {
        if (clubIdInUrl) {
            await getClubEventTemplates(club.clubId, sportTypeId);
        }
        hideSplash();
    };

    useEffect(() => {
        showSplash({
            splash: 'load',
            title: 'Loading',
        });
        getTemplates();
    }, [clubIdInUrl]);

    function closeCreatePage() {
        const { clubId } = club;
        if (clubId) {
            if (isClubRedirectEnabled) {
                showSplash();
                const clubTierTypeId = clubDetails.tierTypeId || clubDetails.tierType?.id;
                const newClubPath = getNewClubPath(clubTierTypeId);
                window.location.href = `${config.nextAppHost}/${newClubPath}/${clubId}`;
                return;
            }
            props.history.push(`/clubs/${clubId}`);
        } else {
            props.history.push(`/home`);
        }
    }

    function currentMemberIsAdmin(clubDetails) {
        return clubDetails.currentMember && (clubDetails.currentMember.role === 'Admin' || clubDetails.currentMember.role === 'Owner');
    }

    function handleClubSelectCancel() {
        props.history.goBack();
    }

    function handleClubSelectSubmit(values) {
        if (values && values.clubId) {
            props.history.push(`/events/create?clubId=${values.clubId}`);
        }
    }

    const { clubDetails, clubDetailsFetched } = club;
    const clubsList = getClubListForCreateEvent(club);
    const { loading, loaded, error } = eventTemplates.templatesFetchState;

    const onPreviewClick = (template) => {
        props.setClubId(club.clubId);
        props.setRedirectUrl(`/events/create?clubId=${club.clubId}`);
        props.history.push(`/event-templates/${template.id}`);
    };

    const templatesToShow = [];
    eventTemplates.templates.forEach(template => {
        if (template.canCreateEvent) {
            templatesToShow.push(template);
        }
    });
    // redirect to normal create page if no template exists
    if (!loading && loaded && !error && templatesToShow.length === 0) {
        handleToCreateForm({});
    }

    return (
        <>
            <div className="navbar navbar-expand-md navbar-light mt0 sticky-top">
                <div className="container" style={{ position: 'relative' }}>
                    <div className="row w-100">
                        <div className="col d-flex aic">
                            <div className="close-area" onClick={closeCreatePage}>
                                <Img className="close-icon" src="/img/icons/close-icon-lg.svg" />
                            </div>
                            <div className="d-inline d-md-none title-span text-medium text-uppercase text-dark text-center">
                                Create Event
                            </div>
                        </div>
                        <div className="col d-none d-md-flex aic jcc">
                            <div className="title-span text-medium text-uppercase text-dark text-center">
                                Create Event
                            </div>
                        </div>
                        <div className="col d-flex aic jce" />
                    </div>
                </div>
            </div>
            <div className={styles.page}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {clubIdInUrl && (
                                <div className={`${styles.section}`}>
                                    {(clubDetailsFetched && (!isClubActive(clubDetails) || !clubDetails || !clubCanRunEvents(clubDetails) || !currentMemberIsAdmin(clubDetails))) && (
                                        <Redirect to="/clubs" />
                                    )}
                                    <div className={`container bg-transparent pl0 pr0 pb8`}>
                                        {clubDetails && (
                                            <div className={`text-highlight2 text-teal`}>
                                                <Link to={`/clubs/${clubDetails.id}`}>{clubDetails.name}</Link>
                                            </div>
                                        )}
                                        <h2>
                                            Create a {sportTypeId === sportTypeIds.PICKLEBALL ? 'Pickleball' : 'Tennis'} Event
                                        </h2>
                                        <div className="bb pb8">
                                            {clubDetails && !clubDetails.eventCount ? 'Let`s start creating your first event' : 'Let`s start creating your next event'}
                                        </div>
                                        <div className="pt24 pb32 bb">
                                            <h6 className="fw600 uc">Start from Scratch</h6>
                                            <button
                                                type="button"
                                                onClick={handleToCreateForm}
                                                className={`btn btn-md btn-primary uc`}
                                            >
                                                Create Event
                                            </button>
                                        </div>
                                        {!loading && loaded && !error && (
                                            <>
                                                <h6 className="fw600 uc">Or select an event template</h6>
                                                <div className="row mb40">
                                                    {templatesToShow.map(template => {
                                                        return (
                                                            <div
                                                                key={`event-template-${template.id}`}
                                                                className="col-12 col-md-4"
                                                            >
                                                                <EventTemplateCard
                                                                    template={template}
                                                                >
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-default uc mr8"
                                                                                onClick={() => onPreviewClick(template)}
                                                                                disabled={!template.canPreview}
                                                                            >
                                                                                Preview
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-default uc"
                                                                                onClick={() => handleToCreateForm({ templateId: template.id })}
                                                                                disabled={!template.canCreateEvent}
                                                                            >
                                                                                Create
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </EventTemplateCard>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                            {!clubIdInUrl && (
                                <>
                                    {clubsList && clubsList.length === 0 && (
                                        <Redirect to="/" />
                                    )}
                                    {clubsList && clubsList.length === 1 && (
                                        <Redirect to={`/events/create?clubId=${clubsList[0].id}`} />
                                    )}
                                    {clubsList && clubsList.length > 1 && (
                                        <div className={styles.section}>
                                            <div className={`container bg-transparent pl0 pr0 pb0`}>
                                                <h2>Select organization</h2>
                                                <h2 className="bb pb32">to create a new event</h2>
                                            </div>
                                            <ClubSelectForm
                                                handleSubmit={handleClubSelectSubmit}
                                                clubsList={clubsList}
                                                cancel={handleClubSelectCancel}
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        showSplash: ({ splash, title, description }) => {
            dispatch(splashActions.showSplash({ splash, title, description }));
        },
        hideSplash: () => dispatch(splashActions.hideSplash()),
        getClubEventTemplates: async (clubId, sportTypeId) => {
            await dispatch(eventTemplateActions.fetchClubEventTemplateList(true, clubId, sportTypeId));
        },
        setRedirectUrl: async (redirectUrl) => {
            await dispatch(eventTemplateActions.setRedirectUrl(redirectUrl));
        },
        setClubId: async (clubId) => {
            await dispatch(eventTemplateActions.setClubId(clubId));
        },
    };
}

function mapStateToProps({ club, eventTemplates }) {
    return { club, eventTemplates };
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
)(EventCreateTemplates);
